import React, { useEffect, useRef } from 'react';
import '../../assets/landingPageCss/common.css';
import '../../assets/landingPageCss/style.css';
import Footer from './Footer';
import Navbar from './Navbar';
import ArrowDownSvg from '../../assets/images/landing/arrowDown.svg'
// import freelanceJson from '../../../assets/images/lotties/freelance.json';
import { Link } from 'react-router-dom';
import FreelanceLottie from './LottiePlayer';
import LottiePlayer from './LottiePlayer';

export default function Home() {
  document.title = 'Adcropper';

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  function handleCollapse(e) {
    let target = e.target;
    if (event.target.className !== 'collapseHeader') {
      target = event.target.parentElement
    }
    target.parentElement.classList.toggle("active");
    const collapseBody = target.nextElementSibling;
    if (collapseBody.style.maxHeight) {
      collapseBody.style.maxHeight = null;
    } else {
      collapseBody.style.maxHeight = collapseBody.scrollHeight + "px";
    }
  }

  return (
    <main className="untitled-page mainContent">
      {/* <div class="loader-container">
         <lottie-player class="loader" id="loader" src="./assets/lotties/loader.json" loop="true"
          autoplay="true"></lottie-player>
        {/* <iframe class="loader" src="https://lottie.host/embed/e884809d-269a-497b-a36b-15fbbb671844/rXVU18w0xr.json"></iframe>
      </div> */}
      <Navbar />
      <section class="heroSection">
        <div class="heroWrapper">
          <LottiePlayer
            className={'bannerAnim'}
            id={'bannerAnim'}
            src={'./landing/freelance.json'}
            frames={[0, 180]}
            visibility={[0, 1.0]}
            actions={[{
              visibility: [0, 0.1],
              type: "stop",
              frames: [0]
            },
            {
              visibility: [0.1, 0.9],
              type: "loop",
              frames: [0, 180]
            },
            {
              visibility: [0.9, 1],
              type: "seek",
              frames: [180]
              // frames: [0, 150]
            },
            ]}
          />
          <div class="heroTextContainer">
            <h1 class="heroTitle">
              Elevate Your <span class="underline"> Ad Game</span>
            </h1>
            <p class="highlightedText">
              Adcropper Platform is a useful creative management and automation tool that simplifies ad creation and allows faster and more efficient ad launching. It integrates with Figma and supports multiple channels such as display, social media, PPC, and email marketing. Adcropper Platform accelerates your design workflow,  improves team efficiency, and enhances overall ad campaign effectiveness.
            </p>
            <div class="actionButtonContainer">
              <Link class="secondBookDemoButton" to={"/book-demo"}>
                Book a demo
              </Link>
              <Link class="exploreFeaturesButton" to={"/features"}>Explore Features</Link>

              {/* <Link class="watchTrailerButton" to={"#"}>
                Watch Trailer
              </Link> */}
            </div>
          </div>
        </div>
      </section>
      {/* Motion Creation Section */}
      <section class="motionCreationSection">
        <div class="flexColumnTwo">
          <div class="flexColumnThree">
            <h1 class="motionCreationTitle">
              Motion creation <span class="underline"> Simplified</span>
            </h1>
            <p class="motionCreationHighlight">Save countless design and development hours with the modern motion
              workflow.</p>
          </div>
          <div class="contentBoxTwo">
            <div class="flexColumnFour">
              <h1 class="launchAdsFasterTitle">
                Launch Ads <span class="underline"> Faster</span>
              </h1>
              <p class="launchAdsHighlight">
                Adcropper Platform accelerates ad launches with its intuitive interface, designed for maximum efficiency. Its user-friendly interface and pre-built templates enable quick creation of visually appealing ads, while automated tools facilitate resizing and formatting for various platforms. Additionally, integrated collaboration features allow teams to work together in real-time, reducing the approval and revision time. This combination ensures that users can launch effective ads rapidly, enhancing productivity and campaign success.
              </p>
              <Link class="thirdBookDemoButton" to={"/book-demo"}>Book a demo</Link>
            </div>
            <div class="carAnimContainer">
              <div class="car"></div>
              <LottiePlayer
                className={'car'}
                id={'car'}
                src={'./landing/global-business.json'}
                frames={[0, 100]}
                visibility={[0, 1.0]}
                actions={[{
                  visibility: [0, 0.1],
                  type: "stop",
                  frames: [0]
                },
                {
                  visibility: [0.1, 0.9],
                  type: "loop",
                  frames: [100]
                },
                {
                  visibility: [0.9, 1],
                  type: "seek",
                  frames: [100]
                  // frames: [0, 150]
                },
                ]}
              />
              {/* <lottie-player class="car" id="car" src="assets/lotties/global-business.json"></lottie-player> */}
            </div>
          </div>
        </div>
      </section>
      {/* Creative Management Section */}
      <section class="creativeManagementSection">
        <div class="flexRowThree">
          <div class="contentBoxThree">
            <div class="flexColumnFive">
              <h1 class="creativeAutomationTitle">
                Creative
                <br />
                Automation
              </h1>
              <p class="adCreationSpeedHighlight">Speed up Your Ad Creation</p>
              <p class="automationBenefitHighlight">
                Get rid of repetitive tasks. Design, automate, and launch ads in minutes, freeing your team for higher-value work. Speed up the ad creation process and grow your business faster.
              </p>
            </div>
            <div class="automation"></div>
            <LottiePlayer
              className={'automation'}
              id={'automation'}
              src={'./landing/dataCenterAutomation.json'}
              frames={[0, 180]}
              actions={[{
                visibility: [0, 0.1],
                type: "stop",
                frames: [0]
              },
              {
                visibility: [0.1, 0.9],
                type: "loop",
                frames: [0, 180]
              },
              {
                visibility: [0.9, 1],
                type: "seek",
                frames: [180]
                // frames: [0, 150]
              },
              ]}
              visibility={[0, 1.0]}
            />
            {/* <lottie-player class="automation" id="automation" src="assets/lotties/dataCenterAutomation.json"></lottie-player> */}

          </div>
          <div class="contentBoxFour">
            <div class="flexColumnSix">
              <h1 class="creativeManagementTitle" id="creativeManagementTitleDesktop">Creative <br /> Management</h1>
              <h1 class="creativeManagementTitle" id="creativeManagementTitleMobile">Creative Management</h1>
              <p class="allPlatformsHighlight">All Major Platforms</p>
              <p class="platformManagementHighlight">
                Move beyond tricky platforms. Create, launch, and update campaigns in real-time across display, social, programmatic, PPC, and email. All from one dashboard.
              </p>
            </div>
            <div class="phone"></div>
            <LottiePlayer
              className={'phone'}
              id={'phone'}
              src={'./landing/mobileOrganizerManagament.json'}
              frames={[0, 90]}
              actions={[{
                visibility: [0, 0.1],
                type: "stop",
                frames: [0]
              },
              {
                visibility: [0.1, 0.9],
                type: "loop",
                frames: [0, 90]
              },
              {
                visibility: [0.9, 1],
                type: "seek",
                frames: [90]
                // frames: [0, 150]
              },
              ]}
              visibility={[0.1, 1.0]} />
            {/* <lottie-player class="phone" id="phone" src="assets/lotties/mobileOrganizerManagament.json"></lottie-player> */}
          </div>
        </div>
      </section>
      {/* Dynamic Feed Section */}
      <section class="dynamicFeedsSection">
        <div class="flexColumnSeven">
          <div class="flexRowFour">
            <div class="contentBoxFive">
              <div class="flexColumnEight">
                <LottiePlayer
                  className={'feed'}
                  id={'feed'}
                  src={'./landing/feed.json'}
                  frames={[0, 180]}
                  actions={[{
                    visibility: [0, 0.1],
                    type: "stop",
                    frames: [0]
                  },
                  {
                    visibility: [0.1, 0.9],
                    type: "loop",
                    frames: [0, 180]
                  },
                  {
                    visibility: [0.9, 1],
                    type: "seek",
                    frames: [180]
                    // frames: [0, 150]
                  },
                  ]}
                  visibility={[0, 1.0]}
                />
                {/* <lottie-player class="feed" id="feed" src="assets/lotties/feed.json"></lottie-player> */}
                <h1 class="dynamicFeedsTitle" id="dynamicFeedsTitleDesktop">Dynamic<br />Feeds</h1>
                <h1 class="dynamicFeedsTitle" id="dynamicFeedsTitleMobile">Dynamic Feeds</h1>
                <p class="dynamicFeedsHighlight">Supercharge Your Ads</p>
                <p class="tasksHighlight">
                  Supercharge your campaigns with dynamic feeds. Fully integrate real time data such as product details and user preferences to craft customised ads that resonate with the audience and maximize conversions!
                </p>
              </div>
            </div>
            <div class="contentBoxSix">
              <div class="flexColumnNine">
                <LottiePlayer
                  className={'templates'}
                  id={'templates'}
                  src={'./landing/templates.json'}
                  frames={[0, 150]}
                  actions={[{
                    visibility: [0, 0.1],
                    type: "stop",
                    frames: [0]
                  },
                  {
                    visibility: [0.1, 2.9],
                    type: "loop",
                    frames: [0, 150]
                  },
                  {
                    visibility: [2.9, 3.0],
                    type: "seek",
                    frames: [150]
                    // frames: [0, 150]
                  },
                  ]}
                  visibility={[0, 3.0]}
                />
                {/* <lottie-player class="templates" id="templates" src="assets/lotties/templates.json"></lottie-player> */}
                <h1 class="readyToGoTemplatesTitle">
                  Ready-to-go
                  <br />
                  Templates
                </h1>
                <p class="instantAdsHighlight">Instant Ads</p>
                <p class="creativityBlockersHighlight">
                  Skip the creativity blockers. Jumpstart your ad creation with our vast collection of ready-to-use designs. Save time while maintaining a professional look and launch campaigns in a moment.
                </p>
              </div>
            </div>
            <div class="contentBoxSeven">
              <div class="flexColumnEightB">
                {/* <div class="cube"></div> */}
                <LottiePlayer
                  className={'cube'}
                  id={'cube'}
                  src={'./landing/cube1.json'}
                  frames={[0, 300]}
                  actions={[{
                    visibility: [0, 0.1],
                    type: "stop",
                    frames: [0]
                  },
                  {
                    visibility: [0.1, 0.9],
                    type: "loop",
                    frames: [0, 300]
                  },
                  {
                    visibility: [0.9, 1],
                    type: "seek",
                    frames: [300]
                    // frames: [0, 150]
                  },
                  ]}
                  visibility={[0, 1.0]}
                />
                {/* <lottie-player class="cube" id="cube" src="assets/lotties/cube1.json"></lottie-player> */}
                <h1 class="scalableForAgenciesTitle">
                  Scalable for
                  <br />
                  Agencies
                </h1>
                <p class="growWithoutLimitsHighlight">Grow Without Limits</p>
                <p class="clientManagementHighlight">
                  Avoid growing pains. Manage several clients from one central platform. Optimise the workflow and handle more clients with ease. Deliver excellent service and grow your agency.
                </p>
              </div>
            </div>
          </div>
          {/* <div class="contentBoxEight">
            <div class="flexRowFive">
              <div class="adForFigmaImage">
                <img class="image5" src="assets/images/figma-logo.svg" draggable="false" alt="Figma Logo" />
                <h1 class="adForFigmaTitle">Adcropper For Figma</h1>
              </div>
              <a class="explorePluginButton" href="#">
                Explore Plugin
              </a>
            </div>
          </div> */}
          <Link class="fourthBookDemoButton" to={"/book-demo"}>
            Book a demo
          </Link>
        </div>
      </section>
      {/* Ad Display Section */}
      <section class="adDisplaySection">
        <div class="flexColumnNineB">

          <div class="flexRowSeven">
            <div class="contentBoxNine">
              <LottiePlayer
                className={'display'}
                id={'display'}
                src={'./landing/monitorDisplay.json'}
                frames={[0, 150]}
                actions={[{
                  visibility: [0, 0.1],
                  type: "stop",
                  frames: [0]
                },
                {
                  visibility: [0.1, 0.9],
                  type: "loop",
                  frames: [0, 150]
                },
                {
                  visibility: [0.9, 1],
                  type: "seek",
                  frames: [150]
                  // frames: [0, 150]
                },
                ]}
                visibility={[0, 1.0]} />
              {/* <lottie-player class="display" id="display" src="assets/lotties/monitorDisplay.json"></lottie-player> */}
              <div class="flexColumnTen">
                <h1 class="displayAdsTitle">Display Ads</h1>
                {/* <p class="displayAdsHighlight">Speed up Your Ad Creation</p> */}
                <p class="adsAutomationHighlight">Enhance your advertising strategy with our expert team dedicated to delivering impactful display ads that drive results.<br /><br />With a focus on captivating visuals and precise targeting, we connect your brand to the right audience, ensuring maximum engagement and growth.<br /><br />Partner with us to elevate your digital presence and achieve measurable success in your campaigns!</p>
              </div>
            </div>
            <div class="contentBoxNineB">
              <LottiePlayer
                className={'crm'}
                id={'crm'}
                src={'./landing/droneCRM.json'}
                frames={[0, 150]}
                actions={[{
                  visibility: [0, 0.1],
                  type: "stop",
                  frames: [0]
                },
                {
                  visibility: [0.1, 0.9],
                  type: "loop",
                  frames: [0, 150]
                },
                {
                  visibility: [0.9, 1],
                  type: "seek",
                  frames: [150]
                  // frames: [0, 150]
                },
                ]}
                visibility={[0, 1.0]}
              />
              {/* <lottie-player class="crm" id="crm" src="assets/lotties/droneCRM.json"></lottie-player> */}
              <div class="flexColumnTenB">
                <h1 class="crmTitle">CRM</h1>
                {/* <p class="crmHighlight">Speed up Your Ad Creation</p> */}
                <p class="crmAutomationHighlight">Unlock the full potential of your marketing with Adcropper Platform's enhanced CRM capability.<br /><br />Track customer interactions and gather valuable insights to create personalized campaigns that appeal to your audience.<br /><br />With powerful analytics and automation features, you can optimize your strategies and drive higher engagement and conversions.</p>
              </div>
            </div>
            <div class="contentBoxNineC">
              <LottiePlayer
                className={'social'}
                id={'social'}
                src={'./landing/social.json'}
                frames={[0, 150]}
                actions={[{
                  visibility: [0, 0.1],
                  type: "stop",
                  frames: [0]
                },
                {
                  visibility: [0.1, 0.9],
                  type: "loop",
                  frames: [0, 150]
                },
                {
                  visibility: [0.9, 1],
                  type: "seek",
                  frames: [150]
                  // frames: [0, 150]
                },
                ]}
                visibility={[0.2, 1.0]} />
              {/* <lottie-player class="social" id="social" src="assets/lotties/social.json"></lottie-player> */}
              <div class="flexColumnEleven">
                <h1 class="socialTitle">Social</h1>
                {/* <p class="socialHighlight">Speed up Your Ad Creation</p> */}
                <p class="socialAutomationHighlight">Amplify your brand's reach with our digital Adcropper Platform's robust social media capabilities.<br /><br />Effortlessly manage and optimize campaigns across multiple social channels, leveraging advanced targeting and analytics to connect with the audience.<br /><br />Drive engagement and boost conversions with customised content that resonates on every platform.</p>
              </div>
            </div>
            <div class="contentBoxNineD">
              <LottiePlayer
                className={'ppc'}
                id={'ppc'}
                src={'./landing/windowPPC.json'}
                frames={[0, 150]}
                actions={[{
                  visibility: [0, 0.1],
                  type: "stop",
                  frames: [0]
                },
                {
                  visibility: [0.1, 0.9],
                  type: "loop",
                  frames: [0, 150]
                },
                {
                  visibility: [0.9, 1],
                  type: "seek",
                  frames: [150]
                  // frames: [0, 150]
                },
                ]}
                visibility={[0, 1.0]} />
              {/* <lottie-player class="ppc" id="ppc" src="assets/lotties/windowPPC.json"></lottie-player> */}
              <div class="flexColumnElevenB">
                <h1 class="ppcTitle">PPC</h1>
                {/* <p class="ppcHighlight">Speed up Your Ad Creation</p> */}
                <p class="ppcAutomationHighlight">Maximize your advertising impact with Adcropper Platform.<br /><br />Easily create and manage pay-per-click campaigns that target the right audience at the right time, ensuring measurable results.<br /><br />With real time analytics and optimization tools, you can fine tune strategies to boost conversions and drive sustainable growth.</p>
              </div>
            </div>
          </div>
          <Link class="getDemoButton" to={"/book-demo"}>
            Book a demo
          </Link>
        </div>
      </section>
      {/* Information Section */}
      <section class="adcropperInformationSection">
        <div class="flexColumnTwelve">
          <div class="collapseMenu">
            <div class="collapseHeader" onClick={handleCollapse}>
              <h2 class="collapseTitle">What is Adcropper?</h2>
              <img class="collapseIcon" src={ArrowDownSvg} alt="alt text" />
            </div>
            <div class="collapseBody">
              <p class="collapseText">Adcropper Platform is a creative automation platform that helps businesses create and launch visual ads and PPC campaigns quickly and easily. It simplifies the ad production process, allowing you to design, optimise, and publish ads across multiple channels from one simple dashboard. By automating repetitive tasks, Adcropper Platform frees up your time so you can focus on strategy and creativity.</p>
            </div>
          </div>
          <div class="collapseMenu">
            <div class="collapseHeader" onClick={handleCollapse}>
              <h2 class="collapseTitle">What is creative automation and how does it work?</h2>
              <img class="collapseIcon" src={ArrowDownSvg} alt="alt text" />
            </div>
            <div class="collapseBody">
              <p class="collapseText">Creative automation is the process of using software to simplify and speed up the creation of digital ads. Adcropper Platform helps automate time consuming tasks such as resizing, formatting, and optimising ads for different platforms. It also allows you to quickly create ads using pre-set templates and adjust designs as needed. This means that the ads can be launched faster and with less manual work, making the campaigns more efficient and effective.</p>
            </div>
          </div>
          <div class="collapseMenu">
            <div class="collapseHeader" onClick={handleCollapse}>
              <h2 class="collapseTitle">Who can use Adcropper?</h2>
              <img class="collapseIcon" src={ArrowDownSvg} alt="alt text" />
            </div>
            <div class="collapseBody">
              <p class="collapseText">Adcropper Platform is designed for advertising agencies and large/small marketing teams. Regardless of managing multiple client campaigns or handling large-scale ad production for an enterprise business, Adcropper Platform makes it easier to create ads quickly while maintaining high quality. It’s also ideal for companies that manage ads across multiple channels and want to simplify their processes.</p>
            </div>
          </div>
          <div class="collapseMenu">
            <div class="collapseHeader" onClick={handleCollapse}>
              <h2 class="collapseTitle">How does Adcropper save time?</h2>
              <img class="collapseIcon" src={ArrowDownSvg} alt="alt text" />
            </div>
            <div class="collapseBody">
              <p class="collapseText">Adcropper Platform helps automate key parts of the ad production process, which cuts down on manual work and speeds up campaign launches. Instead of having to create multiple versions of an ad for different platforms manually, Adcropper Platform allows you to do it all in one place with just a few clicks. Not only speeds up the production process but also reduces the chances of errors, saving both time and effort.</p>
            </div>
          </div>
          <div class="collapseMenu">
            <div class="collapseHeader" onClick={handleCollapse}>
              <h2 class="collapseTitle">Does Adcropper work with different channels?</h2>
              <img class="collapseIcon" src={ArrowDownSvg} alt="alt text" />
            </div>
            <div class="collapseBody">
              <p class="collapseText">Adcropper Platform supports multiple ad channels, including display, social media, PPC, and more. It is possible to create ads that are optimised for different platforms like Google Ads, Facebook, Instagram, and others, all from within Adcropper Platform. This makes it easy to manage the ad campaigns in one place and ensures that ads look great no matter where they are shown.</p>
            </div>
          </div>
          <div class="collapseMenu">
            <div class="collapseHeader" onClick={handleCollapse}>
              <h2 class="collapseTitle">How will Adcropper improve my ad performance?</h2>
              <img class="collapseIcon" src={ArrowDownSvg} alt="alt text" />
            </div>
            <div class="collapseBody">
              <p class="collapseText">Adcropper Platform helps improve ad performance by allowing the launch of high-quality ads faster. By simplifying the design and production process, more frequent campaigns can be run and optimised based on performance. This leads to better targeting, faster launches, and more effective results, helping the business grow more quickly.</p>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </main>
  )
}